import config from 'config/config'
import { classNames } from 'lib/utilities'
import PropTypes from 'prop-types'
import React from 'react'
import { Segment } from 'semantic-ui-react'
import ComponentHeader from './ComponentHeader'

export default class ComponentPlaceholder extends React.Component {
  static propTypes = {
    data: PropTypes.string,
    title: PropTypes.string,
    inactive: PropTypes.bool,
    loading: PropTypes.bool,
  }

  render() {
    console.log('componentPlaceholder')
    const { inline, title = '', inactive, loading = true } = this.props
    const dark = config.theme.dark

    return (
      <div
        className={classNames([
          'componentPlaceholder',
          dark && 'inverted',
          inactive ? 'inactive-window' : 'active-window',
        ])}>
        {/*<ComponentHeader inline={inline} title={loading ? I18n.t('global.loading') : title}/>*/}
        {title && <ComponentHeader inline={inline} title={title} />}
        <Segment
          attached
          className={classNames(['placeholder', dark && 'inverted'])}
          loading={loading}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/Helper/ComponentPlaceholder.jsx